<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h1>
                <span jhiTranslate="design-crosses.title">DESIGN CROSSES</span>
                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
            </h1>
            <span jhiTranslate="design-crosses.preferred.names.disclaimer"></span>
        </div>
    </div>
    <br/>
    <div class="col-md-12">
        <div class="row">
            <div class="col d-flex align-items-center">
                <img class="image-icon-sm" src="content/images/select-parents.png">
                <h4 style="padding-top: 5px;">
                    <span jhiTranslate="design-crosses.select.parents">Select Parent</span>&nbsp;
                </h4>
            </div>
        </div>
        <div class="row">
           <div class="col">
                   <a href (click)="browseList($event)" jhiTranslate="design-crosses.browse-link"></a>&nbsp;
                   <span jhiTranslate="design-crosses.browse-text"></span>
           </div>
            <div class="col d-flex align-items-center justify-content-end">
                <button *ngIf="tabs.length" class="btn btn-sm btn-outline-info" (click)="closeTabs($event)" jhiTranslate="design-crosses.close-tabs"></button>&nbsp;
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <section class="col-md-12">
            <nav>
                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item pe-1">
                        <a class="nav-link" [class.active]="isStudyListActive" (click)="setStudyListActive()"><truncate-span [textInput]="studyName" [maxLength]="30"></truncate-span></a>
                    </li>
                    <li class="nav-item pe-1"  *ngFor="let tab of tabs" role="presentation">
                        <a class="nav-link" (click)="setActive(tab.id)" [class.active]="tab.active">
                            <truncate-span [textInput]="tab.name" [maxLength]="30"></truncate-span>
                            <i class="fa fa-times close-nav-tab" (click)="closeTab(tab)"></i>
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active">
                        <jhi-source-list [studyId]="activeStudyId" [listId]="context.activeGermplasmListId" [listName]="context?.activeListName || studyName"></jhi-source-list>
                    </div>
                </div>
            </nav>
        </section>
    </div>
    <br/>
    <div class="col-md-12">
        <div class="row">
            <div class="col d-flex align-items-center">
                <img class="image-icon-sm" src="content/images/list-types.png">
                <h4 style="padding-top: 5px;">
                    <span jhiTranslate="design-crosses.parent.lists">Parents Lists</span>&nbsp;
                </h4>
            </div>

        </div>
        <div class="row">
            <span jhiTranslate="design-crosses.parent.lists.label"></span>
        </div>
    </div>
    <div class="row mt-2">
        <section class="col-md-6">
            <jhi-parent-list [isFemaleParentsComponent]="true"></jhi-parent-list>
        </section>
        <section class="col-md-6">
            <jhi-parent-list [isFemaleParentsComponent]="false"></jhi-parent-list>
        </section>
    </div>
    <br/>
    <div>
        <div class="row col-md-12">
            <h4>
                <span jhiTranslate="design-crosses.crossing.method">Crossing Method</span>&nbsp;
            </h4>
        </div>
        <div class="row">
            <div class="col-5">
                <label class="col-form-label required" jhiTranslate="design-crosses.crossing.method.label">Choose how you would like to make your crosses:</label>
            </div>
            <div class="col-6">
                <ng-select name="crossingMethodsDropdown" id="crossingMethodsDropdown" width="100%"
                           bindValue="id"
                           [items]="crossingMethods"
                           [(ngModel)]="selectedCrossingMethod"
						   placeholder="{{ 'global.please.choose' | translate }}"
                           [clearable]="true">
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.text | translate }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.text | translate }}
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-5 d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="makeReciprocal" name="makeReciprocal" [disabled]="selectedCrossingMethod === UNKNOWN_MALE" [(ngModel)]="makeReciprocal"/>
                <label class="form-check-label ms-2" for="makeReciprocal" jhiTranslate="design-crosses.make.reciprocal">Make Reciprocal Crosses</label>
                <input class="form-check-input ms-2" type="checkbox" id="excludeSelf" name="excludeSelf" [disabled]="disableExcludeSelfCheckBox()" [(ngModel)]="excludeSelf"/>
                <label class="form-check-label ms-2" for="excludeSelf" jhiTranslate="design-crosses.exclude.selfs">Exclude selfs</label>
            </div>
            <div class="col-7">
                <button (click)="generateCrosses($event)" class="btn btn-primary" [disabled]="disableGenerateCrossesButton()">
                    <span *ngIf="isGeneratingCrosses" class="throbber throbber-btn"></span>
					{{ 'design-crosses.generate.crosses' | translate }}
                </button>
            </div>
        </div>
    </div>
    <br/>
    <div>
        <jhi-preview-crosses></jhi-preview-crosses>
    </div>
    <br/>
    <div class="modal-footer">
        <button (click)="back($event)" type="button" class="btn btn-secondary" value="Cancel">
            <span class="fa fa-ban"></span>&nbsp;{{ 'cancel' | translate }}
        </button>
        <button (click)="continue($event)" class="btn btn-primary ms-2" [disabled]="disableContinueButton()">
            <span *ngIf="isLoading" class="throbber throbber-btn"></span>
			{{ 'continue' | translate }}
        </button>
    </div>
    <br/>
</div>
